import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from '../components/ui/accordion';
import { ScrollReveal } from './ScrollReveal';

export const ServiceFAQ = ({ faqs, heading = "Frequently Asked Questions" }) => {
  return (
    <section className="py-24 md:py-32 bg-[#0a0a0a]">
      <div className="max-w-3xl mx-auto px-6 md:px-12">
        <ScrollReveal>
          <h2 className="font-heading text-4xl md:text-5xl font-bold tracking-tight text-[#F5F5F0] mb-12">{heading}</h2>
        </ScrollReveal>
        <ScrollReveal delay={0.1}>
          <Accordion type="single" collapsible className="space-y-2">
            {faqs.map((faq, i) => (
              <AccordionItem
                key={i}
                value={`faq-${i}`}
                data-testid={`faq-item-${i}`}
                className="border-b border-white/5 bg-[#111111] px-6"
              >
                <AccordionTrigger
                  data-testid={`faq-trigger-${i}`}
                  className="text-[#F5F5F0] text-base md:text-lg font-body font-normal hover:text-[#FF5C35] hover:no-underline py-5 [&[data-state=open]]:text-[#FF5C35]"
                >
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-[#888880] text-sm md:text-base font-body font-light leading-relaxed pb-5">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </ScrollReveal>
      </div>
    </section>
  );
};
